if (document.readyState === 'loading') {
	document.addEventListener('DOMContentLoaded', function () {
		initSearchBar();
	});
} else {
	initSearchBar();
}

function initSearchBar() {
	const searchButton = document.querySelectorAll('[aria-controls="search"]')[0];
	if (!searchButton) {
		return;
	}
	searchButton.addEventListener('click', toggleSearchBar);

	const searchContainer = document.getElementById('search');
	const resetButton = searchContainer.querySelectorAll('[type="reset"]')[0];
	resetButton.addEventListener('click', toggleSearchBar);

	function toggleSearchBar(event) {
		event.preventDefault();
		event.stopPropagation();

		const metaNavigation = document.getElementById('secondary-nav');
		let isHidden = searchContainer.classList.toggle('desktop:hidden');
		metaNavigation.classList.toggle('desktop:hidden');
		metaNavigation.classList.toggle('desktop:flex');  // prevent Css property collision with 'desktop:hidden'
		searchButton.classList.toggle('desktop:hidden');

		searchButton.setAttribute('aria-expanded', (!isHidden).toString());
		resetButton.setAttribute('aria-expanded', (!isHidden).toString());

		const searchInput = document.getElementById('search-input');
		if (isHidden) {
			searchInput.value = ''; // clear search input field
			searchButton.focus(); // set focus to search button for keyboard navigation
		} else {
			searchInput.focus();
		}
	}
}
